import axios from "axios";


const url = Glod.VUE_COMMON_BASE_URL.endsWith('/')?Glod.VUE_COMMON_BASE_URL.slice(0,-1):Glod.VUE_COMMON_BASE_URL;
const baseURL = url + '/survey/api/dw/tPhotoTree'

const testURL = 'http://7e5505b4.r5.cpolar.top'
export function getTree() {
  return axios.request({
      url: `${baseURL}/recordToTree`,
      method: 'get'
  })
}

export function postTree(data) {
  return axios.request({
      url: `${baseURL}`,
      method: 'post',
      data: data
  })
}

export function batchAddTree(data) {
  return axios.request({
      url: `${baseURL}/createBatch`,
      method: 'post',
      data: data
  })
}

export function putTree(data) {
  return axios.request({
      url: `${baseURL}`,
      method: 'put',
      data: data
  })
}
export function delTree(id) {
  return axios.request({
      url: `${baseURL}/${id}`,
      method: 'delete'
  })
}

export function getTips(data) {
  return axios.request({
      url: `${url}/survey/api/dw/tmpGdpoi/getAllKeyword`,
      method: 'post',
      data: data
  })
}

export function saveTree(data) {
  return axios.request({
      url: `${url}/survey/api/dw/tPhotoScheme`,
      method: 'post',
      data: data
  })
}

export function getAllTree() {
  return axios.request({
      url: `${url}/survey/api/dw/tPhotoScheme`,
      method: 'get',
  })
}

export function getsche(data) {
  return axios.request({
      url: `${url}/survey/api/dw/tPhotoScheme/getTreesOfSchema`,
      method: 'get',
      params: data
  })
}
export function putsche(data) {
  return axios.request({
      url: `${url}/survey/api/dw/tPhotoScheme`,
      method: 'put',
      data: data
  })
}

export function delsche(ids) {
  return axios.request({
      url: `${url}/survey/api/dw/tPhotoScheme/${ids}`,
      method: 'delete',
  })
}

export function getTranslate() {
  return axios.request({
      url: `${url}/survey/api/tReplace`,
      method: 'get',
  })
}

export function putTranslate(data) {
  return axios.request({
      url: `${url}/survey/api/tReplace`,
      method: 'put',
      data: data
  })
}

export function dragSort(data) {
  return axios.request({
      url: `${url}/survey/api/dw/tPhotoTree/drag`,
      method: 'post',
      data: data
  })
}


